import { useState, useEffect } from 'react';
import axios from 'axios';
import { DEFAULT_TAX_PERCENTAGE } from '../constants';
import { API_ENDPOINTS } from '../config/api';
import { getDummyRestaurantById } from '../data/dummyRestaurants';

export const useRestaurantDetails = (restaurantId) => {
  const [taxPercentage, setTaxPercentage] = useState(DEFAULT_TAX_PERCENTAGE);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRestaurantDetails = async () => {
      if (!restaurantId) return;
      
      try {
        setLoading(true);
        setError(null);
        const response = await axios.get(API_ENDPOINTS.RESTAURANT_BY_ID(restaurantId));
        console.log("Restaurant details fetched:", response.data);
        setTaxPercentage(response.data.taxPercentage);
      } catch (err) {
        console.error("Failed to load restaurant details:", err);
        const fallback = getDummyRestaurantById(restaurantId);
        if (fallback?.taxPercentage != null) {
          setTaxPercentage(fallback.taxPercentage);
          setError(null);
        } else {
          setError("Failed to load restaurant details");
          setTaxPercentage(DEFAULT_TAX_PERCENTAGE);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurantDetails();
  }, [restaurantId]);

  const calculateTaxAmount = (amount) => {
    return ((amount * taxPercentage) / 100).toFixed(2);
  };

  return {
    taxPercentage,
    loading,
    error,
    calculateTaxAmount
  };
};